import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import { ArrowRight, Search } from "react-bootstrap-icons";
import "../../Assets/Scss/Surveys.scss";
import { useQuery } from "@tanstack/react-query";
import { useSessionStorage } from "usehooks-ts";
import { TailSpin } from "react-loader-spinner";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
function SurveyList() {
  const api = process.env.REACT_APP_DATABASE_URI;
  const [authcode, ,] = useSessionStorage("authToken", "");
  const [show, setShow] = useState(false);
  const [modalText, setModalText] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [sortFilter, setSortFilter] = useState("Closest Deadline");

  const navigate = useNavigate();
  const showModal = (text) => {
    setModalText(text);
    setShow(true);
  };
  const {
    isPending,
    isError,
    data: surveys,
    error,
  } = useQuery({
    queryKey: ["surveys"],
    retry: false,
    queryFn: () =>
      fetch(`${api}/surveys`, {
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authcode}`,
        },
      }).then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok ", error);
        }
        return res.json();
      }),
    select: useCallback(
      (surveys) => {
        let filteredSurveys = surveys;

        //Filtering By search
        if (searchFilter !== "")
          filteredSurveys = surveys.filter((opp) =>
            opp.title.toLowerCase().includes(searchFilter.toLowerCase())
          );

        //Sorting by select
        if (sortFilter === "Closest Deadline") {
          filteredSurveys = [...filteredSurveys].sort(
            (a, b) => new Date(a.deadline) - new Date(b.deadline)
          );
        } else if (sortFilter === "Farthest deadline") {
          filteredSurveys = [...filteredSurveys].sort(
            (a, b) => new Date(b.deadline) - new Date(a.deadline)
          );
        }

        return filteredSurveys;
      },
      [searchFilter, sortFilter]
    ),
  });

  if (isPending) {
    return (
      <TailSpin
        visible={true}
        height="150"
        width="150"
        color="#037EF2"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperClass="spinner"
      />
    );
  }

  if (isError) {
    navigate("/redirect?code=refresh&return_url=/mx-surveys");
    return <h3>Error fetching</h3>;
  }

  /*   const surveysTemp = [
    {
      survey_id: 9,
      title: "Testing notification",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      responsible_id: 4982139,
      scope: "local",
      target_entity: "Tunisia",
      target_lc: "AIESEC in MEDINA",
      creation_date: "2025-01-29T17:44:31.529396",
      deadline: "2025-02-07T00:00:00",
      positions: ["TM", "LCVP", "LCP"],
      survey_url: "https://www.example.com/",
    },
    {
      survey_id: 10,
      title: "Member Satisfaction Survey",
      description:
        "This survey is designed to collect detailed feedback from AIESEC members about their overall experience, leadership development, and areas for improvement. We value your honest opinions as they help us create a better organization that fosters personal growth, global understanding, and professional excellence. Please take your time to answer each question thoroughly.",
      responsible_id: 5012345,
      scope: "national",
      target_entity: "Tunisia",
      target_lc: "AIESEC in TUNIS",
      creation_date: "2025-01-25T12:30:15.123456",
      deadline: "2025-02-10T23:59:59",
      positions: ["LCP", "LCVP", "MM", "TL", "TM"],
      survey_url: "https://www.example.com/membersurvey",
    },
    {
      survey_id: 11,
      title: "Conference Feedback",
      description:
        "We value your feedback on our latest conference! This survey will help us understand what worked well and what areas need improvement for future events. Your insights on the sessions, speakers, logistics, and overall experience are crucial in shaping better conferences for AIESEC members. Please provide detailed feedback so we can make our future events even more impactful.",
      responsible_id: 5078910,
      scope: "international",
      target_entity: "Global",
      target_lc: "AIESEC International",
      creation_date: "2025-02-01T09:15:45.987654",
      deadline: "2025-02-14T18:00:00",
      positions: ["MCP", "MCVP", "LCP", "LCVP"],
      survey_url: "https://www.example.com/conferencefeedback",
    },
    {
      survey_id: 12,
      title: "Leadership Evaluation Survey",
      description:
        "This survey aims to evaluate the performance of AIESEC leadership members and assess their impact on the organization. We are looking for honest, constructive feedback on their decision-making, teamwork, and ability to inspire and lead. Your responses will help us identify strong leaders and areas that need improvement to strengthen our teams.",
      responsible_id: 5102345,
      scope: "local",
      target_entity: "Tunisia",
      target_lc: "AIESEC in Sousse",
      creation_date: "2025-01-20T16:40:00.000000",
      deadline: "2025-02-05T17:30:00",
      positions: ["LCP", "LCVP", "TM", "TL"],
      survey_url: "https://www.example.com/leadershipsurvey",
    },
    {
      survey_id: 13,
      title: "Alumni Survey",
      description:
        "This survey is designed to gather feedback from AIESEC alumni regarding their experiences, professional growth, and how AIESEC has influenced their career and personal life. We are keen to understand the long-term impact of AIESEC and how we can continue engaging alumni in our network and initiatives.",
      responsible_id: 5098765,
      scope: "global",
      target_entity: "Global",
      target_lc: "AIESEC International",
      creation_date: "2025-01-18T14:22:36.756123",
      deadline: "2025-02-18T00:00:00",
      positions: ["MCP", "MCVP"],
      survey_url: "https://www.example.com/alumnisurvey",
    },
    {
      survey_id: 14,
      title: "Cultural Exchange Feedback",
      description:
        "AIESEC provides life-changing cultural exchange experiences, and we would love to hear about yours! This survey is designed to understand how the exchange impacted your personal development, cultural understanding, and professional growth. Your feedback will help us improve future exchanges and create even better experiences for incoming and outgoing participants.",
      responsible_id: 5065432,
      scope: "international",
      target_entity: "Global",
      target_lc: "AIESEC in Cairo",
      creation_date: "2025-02-01T10:05:20.123456",
      deadline: "2025-02-25T23:59:59",
      positions: ["MCP", "MCVP", "LCP"],
      survey_url: "https://www.example.com/culturalexchangesurvey",
    },
    {
      survey_id: 15,
      title: "Impact Evaluation Survey",
      description:
        "We aim to measure the social and professional impact of AIESEC programs on our participants. This survey will help us analyze how AIESEC experiences contribute to leadership development, global citizenship, and professional skills. Your insights are vital for us to refine our programs and create more impactful opportunities for future generations.",
      responsible_id: 5071234,
      scope: "national",
      target_entity: "Tunisia",
      target_lc: "AIESEC in Nabeul",
      creation_date: "2025-01-28T11:25:15.987654",
      deadline: "2025-02-12T23:59:59",
      positions: ["LCP", "LCVP", "MM", "TL"],
      survey_url: "https://www.example.com/impactevaluation",
    },
    {
      survey_id: 16,
      title: "Volunteer Experience Feedback",
      description:
        "Volunteering with AIESEC is a unique journey of learning and contribution. We want to understand your experience as a volunteer and how we can improve it for future participants. This survey focuses on the skills you gained, the challenges you faced, and how AIESEC can enhance the volunteering experience. Your honest feedback is appreciated!",
      responsible_id: 5067890,
      scope: "local",
      target_entity: "Tunisia",
      target_lc: "AIESEC in Monastir",
      creation_date: "2025-01-30T13:30:50.123456",
      deadline: "2025-02-20T00:00:00",
      positions: ["TM", "LCVP", "MM"],
      survey_url: "https://www.example.com/volunteersurvey",
    },
  ]; */

  return (
    <div className="surveyList">
      <Row className="search">
        <Form onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col lg={6}>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">
                  <Search color="#037EF2" />
                </InputGroup.Text>
                <Form.Control
                  value={searchFilter}
                  onChange={(e) => setSearchFilter(e.target.value)}
                  type="text"
                  placeholder="Search here"
                />
              </InputGroup>
            </Col>
            <Col>
              <Form.Control
                value={sortFilter}
                onChange={(e) => setSortFilter(e.target.value)}
                as="select"
              >
                <option>Closest Deadline</option>
                <option>Farthest deadline</option>
              </Form.Control>
            </Col>
          </Row>
        </Form>
      </Row>
      <div className="surveyCards">
        {surveys.map((ele, indx) => (
          <Card className="surveyCard" key={ele.survey_id}>
            <Card.Body className="surveyContent">
              <Row>
                <Col>
                  <Card.Title className="surveyTitle">{ele.title}</Card.Title>
                </Col>
                <Col sm={3} className="text-end">
                  <Card.Text className="surveyDeadline">
                    {dayjs(ele.deadline).diff(dayjs(), "day")} days left
                  </Card.Text>
                </Col>
              </Row>
              <Card.Text className="surveyDesc">
                {ele.description.length <= 150 ? (
                  ele.description
                ) : (
                  <>
                    {ele.description.substring(0, 100)}...
                    <Button
                      variant="link"
                      className="readMore"
                      onClick={() => showModal(ele.description)}
                    >
                      Read More
                    </Button>
                  </>
                )}
              </Card.Text>
            </Card.Body>
            <Card.Footer className="fillNow">
              <a href={ele.survey_url}>
                Fill Now <ArrowRight />
              </a>
            </Card.Footer>
          </Card>
        ))}
      </div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Survey Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalText}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default SurveyList;
